var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1647_17927)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 32,
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 31.5,
    stroke: "white",
    strokeOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_17927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8526 17.4793L34.855 17.4832L40.8535 27.4807C40.8537 27.481 40.8539 27.4814 40.8541 27.4817C41.0374 27.7902 41.0418 28.1769 40.865 28.4926C40.6943 28.7975 40.3618 28.9937 40 28.9937H28C27.6431 28.9937 27.3109 28.8012 27.1313 28.486C26.9565 28.1795 26.9592 27.796 27.1458 27.4819C27.146 27.4815 27.1463 27.4811 27.1465 27.4807L33.145 17.4833L33.1474 17.4793C33.3207 17.1873 33.6476 17 34 17C34.3524 17 34.6793 17.1873 34.8526 17.4793ZM36.5 46C35.671 46 35 45.329 35 44.5V35.5C35 34.671 35.671 34 36.5 34H45.5C46.329 34 47 34.671 47 35.5V44.5C47 45.329 46.329 46 45.5 46H36.5ZM28.9497 44.9497C27.637 46.2625 25.8565 47 24 47C22.1435 47 20.363 46.2625 19.0503 44.9497C17.7375 43.637 17 41.8565 17 40C17 38.1435 17.7375 36.363 19.0503 35.0503C20.363 33.7375 22.1435 33 24 33C25.8565 33 27.637 33.7375 28.9497 35.0503C30.2625 36.363 31 38.1435 31 40C31 41.8565 30.2625 43.637 28.9497 44.9497Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1647_17927",
    x: -3.6,
    y: -3.53945,
    width: 71.2,
    height: 71.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1647_17927"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1647_17927",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_17927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCharacter);
export default __webpack_public_path__ + "static/media/white_character.5bddd3fc8d76682046d912647efb7d6a.svg";
export { ForwardRef as ReactComponent };